export const navigation = {
    aria: {
        mainpage: 'Navigate to home page',
        uploadButton: 'Open the 3D printing configurator to upload files',
    },
    labels: {
        account: 'Account',
        language: 'Language',
        uploadFile: 'Upload file',
        userPortal: 'User Portal',
    },
};
